import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { Hr, Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const UnpublishedProductEcommContent = ({ productColor  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("section", {
        className: "unpublished-product-ecomm-content"
    }, productColor && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        color: "text-secondary",
        "data-t": "productColor-text",
        className: "unpublished-product-ecomm-content__product-color"
    }, productColor)), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        icon: "info",
        message: getLabel('products.unpublished.productUnavailable')
    }));
};

export { UnpublishedProductEcommContent };
//# sourceMappingURL=UnpublishedProductEcommContent.js.map
